<template>
  <!--    main-->
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li">
                <div class="form__ttl">휴대폰 번호</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="number" placeholder="휴대폰 번호 입력" v-model="params.contactPhone" @input="numberOnly(params.contactPhone, 'contactPhone')" maxlength="11">
                    </label>
                    <button class="btn type_02" @click="sendPhoneAuth">{{ sendPhoneAuthText }}</button> <!--노란색 버튼은 type_02-->
                  </div>
                  <div class="inline" v-show="isSendAuth">
                    <label class="input timer">
                      <input type="number" placeholder="인증코드 입력" v-model="params.authCode" @input="numberOnly(params.authCode, 'authCode')" maxlength="4" :disabled="isConfirmAuth">
                      <span class="time" v-show="!isConfirmAuth">{{ timer }}</span>
                    </label>
                    <button class="btn type_02" @click="confirmPhoneAuthCode">확인</button> <!--노란색 버튼은 type_02-->
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm" :class="{'on': isConfirmAuth}" @click="complete">아이디 찾기</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>

export default {
  data: function () {
    return {
      expired: false,
      timer: '5:00',
      sendPhoneAuthText: '인증',
      countDownInterval: null,
      isSendAuth: false,
      isConfirmAuth: false,
      findUserID: '',
      params: {
        contactPhone: '',
        authCode: '',
        authToken: ''
      }
    }
  },
  watch: {
    'params.contactPhone': function () {
      this.isConfirmAuth = false
    },
  },
  methods: {
    numberOnly: function (value, type) {
      switch (type) {
        case 'contactPhone':
          this.isConfirmAuth = false
          this.isSendAuth = false
          this.timer = '5:00'
          this.params.authCode = ''

          this.params.contactPhone = this.$Util.maxLengthCheck(this.$Util.numberOnly2(value), 11)
          break
        case 'authCode':
          this.params.authCode = this.$Util.maxLengthCheck(this.$Util.numberOnly2(value), 4)
          break
      }
    },
    /**
     * 휴대폰 인증번호 확인
     */
    confirmPhoneAuthCode: function () {
      if (this.expired) {
        this.$Util.modalAlert({message: '인증시간이 만료되었습니다.<br>재 인증 해주세요.'})
        return false
      }

      if(this.params.authCode.length <= 0) {
        this.$Util.modalAlert({message: '인증코드를 입력해주세요.'})
        return false
      }

      let params = {
        contactPhone: this.params.contactPhone,
        authCode: this.params.authCode,
        authToken: this.params.authToken
      }

      this.$CommonSvc.confirmPhoneAuthCode(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log(entity)
          if (code === 1) {
            this.$Util.modalAlert({message: '인증 되었습니다.'})
            this.isConfirmAuth = true
            clearInterval(this.countDownInterval)
            this.findUserID = entity
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    },
    /**
     * 휴대폰 인증번호 발송
     */
    sendPhoneAuth: function () {
      if(this.params.contactPhone.length <= 0) {
        this.$Util.modalAlert({message: '휴대폰번호를 입력해주세요.'})
        return false
      }

      if(!this.$Util.isPhoneValid(this.params.contactPhone)) {
        this.$Util.modalAlert({message: '올바른 휴대폰번호를 입력해주세요.'})
        return false
      }

      let params = {
        authType: 2,
        contactPhone: this.params.contactPhone
      }

      this.$CommonSvc.sendPhoneAuth(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            // TODO 알럿 교체 (테스트용 코드 노출)
            // this.$Util.modalAlert({message: '인증코드가 발송 되었습니다. [' + entity['authCode(DEBUG)'] + ']'})
            this.$Util.modalAlert({message: '인증코드가 발송 되었습니다.'})
            this.params.authToken = entity.authToken
            this.params.authCode = ''
            this.isConfirmAuth = false
            this.isSendAuth = true
            this.sendPhoneAuthText = '재인증'
            this.expired = false
            this.timer = '5:00'
            this.countDown()
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    },
    countDown: function () {
      clearInterval(this.countDownInterval)
      let duration = this.$moment.duration({
        'minutes': '5',
        'seconds': '00'
      })
      const _this = this
      this.countDownInterval = setInterval(function () {
        duration = _this.$moment.duration(duration.asSeconds() - 1, 'seconds')
        let min = duration.minutes()
        let sec = duration.seconds()
        if (Number(sec) < 0) {
          _this.timer = '0:00'
          _this.expired = true
          clearInterval(_this.countDownInterval)
          return false
        }
        if (sec < 10) {
          sec = '0' + sec
        }

        _this.timer = min + ':' + sec
      }, 1000)
    },
    complete: function () {
      if (!this.isConfirmAuth) {
        this.$Util.modalAlert({message: '인증절차를 완료 해주세요.'})
        return false
      }

      this.$AccountSvc.findUserID(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            this.findUserID = entity
            const data = {
              message: this.findUserID
            }
            this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.FINDID, data)
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    },
  }
}
</script>

